export abstract class StoreBase {
    isBusy = false
}